import React, {useEffect, useRef, useState} from "react";
import {Link} from "react-router-dom";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import {IconButton} from "@material-ui/core";
import {MdDeleteForever, MdEdit} from "react-icons/md";
import {IoIosArrowBack, IoIosArrowForward} from "react-icons/io";
import {AiOutlineSearch} from "react-icons/ai";
import AlertDelete from "../../components/Alert/AlertDelete";
import CustomButton from "../../components/Form/Button";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableFooter from "@mui/material/TableFooter";
import messageTypes from "../../constants/MessagesTypes";
import {getDisciplinas} from "../../services/Disciplina";
import {useSelector} from "react-redux";
import * as Yup from "yup";
import {toast} from "react-toastify";
import {dateCurrent, dateFirstDayCurrent, firstDayMonth} from "../../utils/date";
import {Form} from "@unform/web";
import InputDate from "../../components/Form/InputDate";
import {useTranslation} from "react-i18next";
import DivDiagonal from "../../components/DivDiagonal";
import {
    TradingWrapper,
    ContentArea,
    HeaderActions,
    NewTradingButton,
    FilterSection,
    FilterTitle,
    StyledFilterFormWrapper,
    FilterField,
    FilterButtonWrap,
    ResultBadge,
} from "../Trading/styles";
import {
    StrategyPageHeader,
    StrategyCardColumn,
    StrategyProductCard,
    StrategyTableContainer,
    StrategyTableWrapper,
    StrategyActionButtons,
    StrategyPaginationInfo,
    StrategyPaginationButton,
    StrategyLoadingButton,
    StrategyEmptyState,
} from "../Strategy/styles";
import styled from "styled-components";

const filterSearchBtnStyle = {
    background: 'linear-gradient(135deg, #f29205 0%, #ff6b35 100%)',
    border: 'none',
    color: '#ffffff',
    padding: '0 28px',
    borderRadius: '10px',
    fontWeight: 600,
    boxShadow: '0 4px 15px rgba(242, 146, 5, 0.3)',
    transition: 'all 0.3s ease',
    minHeight: '48px',
};

const ReportNavLink = styled(Link)`
    background: linear-gradient(135deg, rgba(10, 14, 39, 0.95) 0%, rgba(22, 33, 62, 0.98) 100%);
    border: 2px solid rgba(242, 146, 5, 0.75);
    color: #ffffff !important;
    padding: 10px 18px;
    border-radius: 10px;
    font-weight: 600;
    font-size: 14px;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    text-decoration: none !important;
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.35);
    transition: all 0.3s ease;
    min-height: 44px;

    @media (min-width: 768px) {
        padding: 12px 22px;
        font-size: 16px;
    }

    &:hover {
        background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
        border-color: #f29205;
        color: #ffffff !important;
        transform: translateY(-2px);
        box-shadow: 0 6px 20px rgba(0, 0, 0, 0.45);
    }
`;

/** Card mais largo que a listagem de estratégias — espaço para datas + Buscar na mesma linha */
const DisciplineCardColumn = styled(StrategyCardColumn)`
    max-width: 100%;
    width: 100%;

    @media (min-width: 576px) {
        max-width: 720px;
    }

    @media (min-width: 768px) {
        max-width: 960px;
    }

    @media (min-width: 1200px) {
        max-width: 1100px;
    }
`;

/** Linha do filtro: em desktop, datas agrupadas + botão à direita (sem quebrar só sob o 1º campo) */
const DisciplineFilterRow = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    align-items: stretch;

    @media (min-width: 768px) {
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: flex-end;
        gap: 16px;
    }
`;

const DisciplineFilterDates = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    flex: 1 1 auto;
    min-width: 0;

    @media (min-width: 768px) {
        flex-direction: row;
        flex: 1 1 0;
        gap: 16px;
    }
`;

const DisciplineFilterField = styled(FilterField)`
    @media (min-width: 768px) {
        flex: 1 1 0;
        min-width: 0;
        max-width: none;
    }
`;

const DisciplineFilterButtonWrap = styled(FilterButtonWrap)`
    width: 100%;

    @media (min-width: 768px) {
        flex: 0 0 auto;
        width: auto;
        justify-content: flex-end;
    }

    & > * {
        width: 100%;
    }

    @media (min-width: 768px) {
        & > * {
            width: auto;
            min-width: 148px;
        }
    }
`;

export default function Disciplina() {
    const [loading, setLoading] = useState(false);
    const [list, setList] = useState([]);
    const [page, setPage] = useState(1);
    const [total, setTotal] = useState(0);
    const [deleteDisciplina, setDeleteDisciplina] = useState(null);
    const {isActiveSignature} = useSelector(
        (state) => state.UserReducer
    );
    const { t } = useTranslation();

    const formRef = useRef(null);

    const [filter, setFilter] = useState({
        startDate: dateFirstDayCurrent(),
        endDate: dateCurrent(),
    });

    async function handleSubmit(data) {
        try {

            formRef.current.setErrors({});
            const schema = Yup.object().shape({});

            await schema.validate(data, {
                abortEarly: false,
            });

            setFilter({
                startDate: data.startDate,
                endDate: data.endDate,
            });

        } catch (err) {
            if (err instanceof Yup.ValidationError) {
                const validationErrors = {};
                err.inner.forEach((error) => {
                    validationErrors[error.path] = error.message;
                });
                formRef.current.setErrors(validationErrors);
                toast.warning(messageTypes.REQUIRED_FIELDS);
                return;
            }

            toast.error(messageTypes.ERROR);
        }
    }

    useEffect(() => {
        let cancelled = false;

        async function load() {
            setLoading(true);
            const data = await getDisciplinas({
                page: page,
                per_page: 25,
                startDate: filter.startDate,
                endDate: filter.endDate,
            });

            if (cancelled) {
                return;
            }

            if (!data || data === '') {
                setLoading(false);
                return;
            }

            setTotal(data.data.total);
            setList(data.data);
            setLoading(false);
        }

        load();

        return function cleanup() {
            cancelled = true;
            setList([]);
        };
    }, [page, deleteDisciplina === true, filter]);

    return (
        <>
            {isActiveSignature && (
                <TradingWrapper>
                    <DivDiagonal />
                    <ContentArea>
                        <StrategyPageHeader>
                            <h1>
                                <i className="fa fa-graduation-cap" aria-hidden="true"/>
                                {' '}{t('discipline_card_title')}{' '}
                                <span className="badge">{total}</span>
                            </h1>
                            <HeaderActions>
                                <ReportNavLink to="/disciplina/report">
                                    <i className="far fa-file-alt" aria-hidden="true"/>
                                    {t('report')}
                                </ReportNavLink>
                                <NewTradingButton as={Link} to="/disciplina/new">
                                    <i className="fas fa-plus"/> {t('add')}
                                </NewTradingButton>
                            </HeaderActions>
                        </StrategyPageHeader>

                        <DisciplineCardColumn>
                            <StrategyProductCard>
                                <FilterSection>
                                    <StyledFilterFormWrapper>
                                        <Form ref={formRef} onSubmit={handleSubmit}>
                                            <FilterTitle>
                                                <i className="fas fa-funnel-dollar"/> {t('filter')}
                                            </FilterTitle>
                                            <DisciplineFilterRow>
                                                <DisciplineFilterDates>
                                                    <DisciplineFilterField>
                                                        <InputDate
                                                            name="startDate"
                                                            label={t('filter_start_date')}
                                                            value={firstDayMonth()}
                                                            size="small"
                                                        />
                                                    </DisciplineFilterField>
                                                    <DisciplineFilterField>
                                                        <InputDate
                                                            name="endDate"
                                                            label={t('filter_end_date')}
                                                            value={new Date()}
                                                            size="small"
                                                        />
                                                    </DisciplineFilterField>
                                                </DisciplineFilterDates>
                                                <DisciplineFilterButtonWrap>
                                                    <CustomButton
                                                        className="btn font-weight-bold text-capitalize mobile-button"
                                                        type="submit"
                                                        startIcon={<AiOutlineSearch/>}
                                                        style={filterSearchBtnStyle}
                                                        onMouseEnter={(e) => {
                                                            e.currentTarget.style.transform = 'translateY(-2px)';
                                                            e.currentTarget.style.boxShadow = '0 6px 20px rgba(242, 146, 5, 0.4)';
                                                        }}
                                                        onMouseLeave={(e) => {
                                                            e.currentTarget.style.transform = 'translateY(0)';
                                                            e.currentTarget.style.boxShadow = '0 4px 15px rgba(242, 146, 5, 0.3)';
                                                        }}
                                                    >
                                                        {t('filter_btn_submmit')}
                                                    </CustomButton>
                                                </DisciplineFilterButtonWrap>
                                            </DisciplineFilterRow>
                                        </Form>
                                    </StyledFilterFormWrapper>
                                </FilterSection>

                                <StrategyTableWrapper>
                                    {loading ? (
                                        <StrategyLoadingButton
                                            className="btn btn-primary text-capitalize font-weight-bold"
                                            loading={loading}
                                            type="button"
                                        >
                                            {t('loading')}
                                        </StrategyLoadingButton>
                                    ) : (
                                        <>
                                            {list && list.data && list.data.length ? (
                                                <>
                                                    <StrategyTableContainer>
                                                        <Table aria-label={t('discipline_card_title')}>
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell align="center">{t('discipline_table_col_date')}</TableCell>
                                                                    <TableCell align="center">{t('discipline_table_col_management_followed')}</TableCell>
                                                                    <TableCell align="center">{t('discipline_table_col_error_description')}</TableCell>
                                                                    <TableCell align="center">{t('discipline_table_col_options')}</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {list.data.map((row) => (
                                                                    <TableRow key={row.id}>
                                                                        <TableCell align="center" component="th" scope="row">
                                                                            {new Date(row.created.date).toLocaleDateString()}
                                                                        </TableCell>
                                                                        <TableCell align="center">
                                                                            {row.isManagementFollowed ? (
                                                                                <ResultBadge style={{
                                                                                    background: 'rgba(46, 204, 113, 0.2)',
                                                                                    color: '#5bd37c',
                                                                                    border: '1px solid rgba(46, 204, 113, 0.45)',
                                                                                }}>
                                                                                    {t('discipline_fieldset_option_1')}
                                                                                </ResultBadge>
                                                                            ) : (
                                                                                <ResultBadge style={{
                                                                                    background: 'rgba(255, 107, 107, 0.2)',
                                                                                    color: '#ff8a8a',
                                                                                    border: '1px solid rgba(255, 107, 107, 0.45)',
                                                                                }}>
                                                                                    {t('discipline_fieldset_option_2')}
                                                                                </ResultBadge>
                                                                            )}
                                                                        </TableCell>
                                                                        <TableCell align="center">
                                                                            {row.errorDescription && row.errorDescription !== '' && (
                                                                                <small style={{ color: 'rgba(255, 255, 255, 0.75)' }}>
                                                                                    {row.errorDescription}
                                                                                </small>
                                                                            )}
                                                                        </TableCell>
                                                                        <TableCell align="center">
                                                                            <StrategyActionButtons>
                                                                                <Link to={`/disciplina/${row.id}/edit`}>
                                                                                    <IconButton aria-label="edit">
                                                                                        <MdEdit/>
                                                                                    </IconButton>
                                                                                </Link>
                                                                                <IconButton
                                                                                    aria-label="delete"
                                                                                    onClick={() => {
                                                                                        setDeleteDisciplina(row.id);
                                                                                    }}
                                                                                >
                                                                                    <MdDeleteForever/>
                                                                                </IconButton>
                                                                            </StrategyActionButtons>
                                                                        </TableCell>
                                                                    </TableRow>
                                                                ))}
                                                            </TableBody>
                                                            <TableFooter>
                                                                <TableRow>
                                                                    <TableCell colSpan={4}>
                                                                        <div style={{
                                                                            display: 'flex',
                                                                            justifyContent: 'space-between',
                                                                            alignItems: 'center',
                                                                            flexWrap: 'wrap',
                                                                            gap: 12,
                                                                        }}>
                                                                            <StrategyPaginationInfo>
                                                                                {t('table_pagination_text', {
                                                                                    page,
                                                                                    totalPage: list.total_page + 1,
                                                                                })}
                                                                            </StrategyPaginationInfo>
                                                                            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                                                                                <StrategyPaginationButton
                                                                                    type="button"
                                                                                    onClick={() => setPage(page - 1)}
                                                                                    disabled={page <= 1}
                                                                                >
                                                                                    <IoIosArrowBack/> {t('table_pagination_back')}
                                                                                </StrategyPaginationButton>
                                                                                <StrategyPaginationButton
                                                                                    type="button"
                                                                                    onClick={() => setPage(page + 1)}
                                                                                    disabled={!list.next_page}
                                                                                >
                                                                                    {t('table_pagination_next')} <IoIosArrowForward/>
                                                                                </StrategyPaginationButton>
                                                                            </div>
                                                                        </div>
                                                                    </TableCell>
                                                                </TableRow>
                                                            </TableFooter>
                                                        </Table>
                                                    </StrategyTableContainer>
                                                    {deleteDisciplina && typeof deleteDisciplina === 'string' && (
                                                        <AlertDelete
                                                            setSuccessDelete={setDeleteDisciplina}
                                                            urlDelete={`${process.env.REACT_APP_API_ENDPOINT}/api/disciplina/delete/${deleteDisciplina}`}
                                                        />
                                                    )}
                                                </>
                                            ) : (
                                                <StrategyEmptyState>
                                                    <i className="fa fa-graduation-cap" aria-hidden="true"/>
                                                    <p>{t('discipline_empty_title')}</p>
                                                    <span>{t('discipline_empty_subtitle')}</span>
                                                </StrategyEmptyState>
                                            )}
                                        </>
                                    )}
                                </StrategyTableWrapper>
                            </StrategyProductCard>
                        </DisciplineCardColumn>
                    </ContentArea>
                </TradingWrapper>
            )}
        </>
    );
}
